import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { changeOpenedModal } from '../../../redux/actions/headerModal';
import LoadingAvatar from '../../../components/LoadingAvatar';
import { defaultImgCDN, imageString } from '../../../helper';
import { getOrganization } from '../../../redux/actions/organization';
import { setToast } from '../../../redux/actions/window';
import DetailsModalTitleButtons from '../../../components/DetailsModalTitleButtons';
import { useTranslation } from 'react-i18next';
import { UserRole } from '../../users/constant';
import { LOADING_BLUE } from '../../../utils/colorCode';
import { ModalHeader, StyledModal, StyledModalBody } from '../../../components/Modals';
import {
  SettingsItem,
  SettingsItemContent,
  SettingsItemSubTitle,
  SettingsItemTitle
} from '../../settings/SettingsItem';
import { FaHouseUser, FaLock } from 'react-icons/fa';
import { Palette } from '../../../components/utils';
import { BiWorld } from 'react-icons/bi';
import { MdOutlineEmail, MdOutlineMarkunreadMailbox } from 'react-icons/md';
import { GiLockers } from "react-icons/gi";
import { GoOrganization } from 'react-icons/go';
import { IoIosInformationCircleOutline } from 'react-icons/io';
import { ImageContainer, StyledImage } from '../../settings/SettingsImages';
import {IoSettingsOutline} from 'react-icons/io5';
import Configurations from '../Organization/Configurations';
import {useGetConfigs} from '../../../hooks/useGetConfigs';
import { getLockProviderNameByID, getSmartLockerProviderNameByID } from '../../../utils/utils';
import { conformToMask } from 'react-text-mask';
import { phoneNumberMask } from '../../../helper/Regx';
import { Flex } from '../../../components/ui/Flex';

const BuildingDetails = () => {
  const { t } = useTranslation();
  const { modal } = useSelector((state) => state.headerModal);
  const { building, status } = useSelector((state) => state.building);
  const { roleId } = useSelector((state) => state.auth);
  const { config } = useGetConfigs();
  const [errorImage, setErrorImage] = useState('');
  const dispatch = useDispatch();

  const onClose = () => {
    setErrorImage('');
    dispatch(
      changeOpenedModal({
        modal: ''
      })
    );
  };

  return (
    modal === 'BuildingDetail' && (
      <StyledModal show={modal === 'BuildingDetail'} onClose={onClose} closeOnBackdrop={true}>
        <ModalHeader title={t('Building details')} />
        {status === 'GET_BUILDING_PENDING' ? (
          <LoadingAvatar color={LOADING_BLUE} />
        ) : (
          <>
            <StyledModalBody>
              <div className="flex justify-content-center">
                <ImageContainer borderRadius='0'>
                  <StyledImage
                    objectFit='contain'
                    onError={() => setErrorImage(defaultImgCDN)}
                    src={errorImage === '' ? imageString(building.photo) : errorImage}
                  />
                </ImageContainer>
              </div>

              <SettingsItem>
                <IoIosInformationCircleOutline size={24} color={Palette.HAZY_BLUE} />
                <SettingsItemContent>
                  <SettingsItemTitle>{t('Building name')}</SettingsItemTitle>
                  <SettingsItemSubTitle>{building.name}</SettingsItemSubTitle>
                </SettingsItemContent>
              </SettingsItem>

              <SettingsItem>
                <GoOrganization size={24} color={Palette.HAZY_BLUE} />
                <SettingsItemContent>
                  <SettingsItemTitle>{t('Organization Name')}</SettingsItemTitle>
                  <SettingsItemSubTitle
                    link={parseInt(roleId) === UserRole.SUPER_ADMIN}
                    onClick={() => {
                      parseInt(roleId) === UserRole.SUPER_ADMIN &&
                        dispatch(
                          getOrganization({
                            id: building.org_id,

                            success: () => {
                              dispatch(
                                changeOpenedModal({
                                  modal: 'OrganizationDetail'
                                })
                              );
                            }
                          })
                        );
                    }}>
                    {building.org}
                  </SettingsItemSubTitle>
                </SettingsItemContent>
              </SettingsItem>

              {/* Building contacts */}
              {building.contacts && building.contacts.length > 0 && (
                <Flex direction="column" gap="8px">
                  <SettingsItem>
                    <MdOutlineEmail size={24} color={Palette.HAZY_BLUE} />
                    <SettingsItemContent>
                      <SettingsItemTitle>{t('Building Contacts')}</SettingsItemTitle>
                    </SettingsItemContent>
                  </SettingsItem>

                  <Flex direction="column" gap="16px">
                    {building.contacts.map((contact, i) => (
                      <div key={contact.id} style={{ marginLeft: '40px' }}>
                        <SettingsItem>
                          <SettingsItemContent>
                            <SettingsItemTitle>{contact.contact_name ? `${contact.contact_name}` : `${t('Contact')} ${i + 1}`}</SettingsItemTitle>
                            {contact.contact_email && (
                              <SettingsItemSubTitle>
                                {t('Email')}: {contact.contact_email}
                              </SettingsItemSubTitle>
                            )}
                            {contact.phone && (
                              <SettingsItemSubTitle>
                                {t('Phone')}: {(conformToMask(contact.phone, phoneNumberMask) || {}).conformedValue}
                              </SettingsItemSubTitle>
                            )}
                          </SettingsItemContent>
                        </SettingsItem>
                      </div>
                    ))}
                  </Flex>
                </Flex>
              )}

              <SettingsItem>
                <BiWorld size={24} color={Palette.HAZY_BLUE} />
                <SettingsItemContent>
                  <SettingsItemTitle>{t('Country')}</SettingsItemTitle>
                  <SettingsItemSubTitle>{building.country}</SettingsItemSubTitle>
                </SettingsItemContent>
              </SettingsItem>

              <SettingsItem>
                <BiWorld size={24} color={Palette.HAZY_BLUE} />
                <SettingsItemContent>
                  <SettingsItemTitle>{t('City')}</SettingsItemTitle>
                  <SettingsItemSubTitle>{building.city}</SettingsItemSubTitle>
                </SettingsItemContent>
              </SettingsItem>

              <SettingsItem>
                <BiWorld size={24} color={Palette.HAZY_BLUE} />
                <SettingsItemContent>
                  <SettingsItemTitle>{t('State / Province')}</SettingsItemTitle>
                  <SettingsItemSubTitle>{building.state}</SettingsItemSubTitle>
                </SettingsItemContent>
              </SettingsItem>

              <SettingsItem>
                <BiWorld size={24} color={Palette.HAZY_BLUE} />
                <SettingsItemContent>
                  <SettingsItemTitle>{t('Zip / Postal code')}</SettingsItemTitle>
                  <SettingsItemSubTitle>{building.zip}</SettingsItemSubTitle>
                </SettingsItemContent>
              </SettingsItem>

              <SettingsItem>
                <MdOutlineMarkunreadMailbox size={24} color={Palette.HAZY_BLUE} />
                <SettingsItemContent>
                  <SettingsItemTitle>{t('Address')}</SettingsItemTitle>
                  <SettingsItemSubTitle>{building.address}</SettingsItemSubTitle>
                </SettingsItemContent>
              </SettingsItem>
              {
                config?.suite_enabled &&
                <SettingsItem>
                  <FaHouseUser size={24} color={Palette.HAZY_BLUE} />
                  <SettingsItemContent>
                    <SettingsItemTitle>
                      {t('Number of units')}
                    </SettingsItemTitle>
                    <SettingsItemSubTitle>{building.suites}</SettingsItemSubTitle>
                  </SettingsItemContent>
                </SettingsItem>
              }

              <SettingsItem>
                <FaHouseUser size={24} color={Palette.HAZY_BLUE} />
                <SettingsItemContent>
                  <SettingsItemTitle>
                    {config?.suite_enabled
                      ? t('Number of rooms')
                      : t('Number of units')}
                  </SettingsItemTitle>
                  <SettingsItemSubTitle>{building.units}</SettingsItemSubTitle>
                </SettingsItemContent>
              </SettingsItem>
            {(config && parseInt(roleId) === UserRole.SUPER_ADMIN) && (
              <>
                <SettingsItem>
                  <FaLock size={24} color={Palette.HAZY_BLUE} />
                  <SettingsItemContent>
                    <SettingsItemTitle>Lock Provider</SettingsItemTitle>
                    <SettingsItemSubTitle>
                      {getLockProviderNameByID(building?.config?.lock_provider)}
                    </SettingsItemSubTitle>
                  </SettingsItemContent>
                </SettingsItem>
                <SettingsItem>
                  <GiLockers size={26} color={Palette.HAZY_BLUE} />
                  <SettingsItemContent>
                    <SettingsItemTitle>{t('Smart Locker Provider')}</SettingsItemTitle>
                    <SettingsItemSubTitle>
                      {getSmartLockerProviderNameByID(building?.config?.smart_locker_provider ?? 0)}
                    </SettingsItemSubTitle>
                  </SettingsItemContent>
                </SettingsItem>
                <SettingsItem>
                  <IoSettingsOutline size={24} color={Palette.HAZY_BLUE} />
                  <SettingsItemContent>
                    <SettingsItemTitle>Configuration</SettingsItemTitle>
                  </SettingsItemContent>
                </SettingsItem>
                <Configurations values={building} fieldName={'config'} isReadOnly isEdit isOrg={false} />
              </>
            )}
            </StyledModalBody>
            {config?.org_allow_edits && (
              <DetailsModalTitleButtons
                className="editButtinDiv mb-3"
                colClassName="text-center editIconDiv"
                handleClick={() => {
                  dispatch(changeOpenedModal({ modal: 'editBuilding' }));
                }}
                editText={t('Edit')}
              />
            )}
          </>
        )}
      </StyledModal>
    )
  );
};

export default BuildingDetails;
